/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useMemo, useState } from 'react';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { useAuthState } from '@core/configureStore';
import { buildCallbackURL } from '@utils/string.util';
import { Button, Col, Divider, Row } from 'antd';

type Props = {};

const ManualSharingScreen = (props: Props) => {
  const [copied, setCopied] = useState(false);
  const { user } = useAuthState();
  const callbackURL = useMemo(
    () =>
      user && user.selected_location ? buildCallbackURL(user.selected_location.location_id) : '',
    [user]
  );
  const handleCopyURL = () => {
    navigator.clipboard.writeText(callbackURL);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };
  return (
    <div>
      <Row>
        <Col span={8}>
          <div
            className="screen-card"
            style={{ borderRight: `1px solid ${GLOBAL_THEME_COLOR.$border_color}` }}>
            <h3>Manual Sharing</h3>
            <Divider />
            <p>Copy link below and share this to anyone to generate a new review</p>
            <Button
              icon={
                copied ? (
                  <CheckOutlined
                    style={{ color: GLOBAL_THEME_COLOR.$success_color, fontWeight: 'bold' }}
                  />
                ) : (
                  <CopyOutlined />
                )
              }
              onClick={handleCopyURL}
              style={{
                width: '100%',
                wordBreak: 'break-all',
                overflow: 'hidden',
                marginTop: 30,
                marginBottom: 30,
              }}>
              {callbackURL}
            </Button>
            <p>The right section is the preview of what the link navigate people to</p>
            <br />
            <p>
              Review Circle defends your brands by only allowing positive reviews to be made public.
              Negative reviews will be routed to you privately.
            </p>
          </div>
        </Col>
        <Col span={16}>
          <iframe
            src={callbackURL}
            style={{ height: '100vh', width: '100%', margin: 0, border: 'none' }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ManualSharingScreen;
